import { useEffect, useLayoutEffect, useMemo, useState } from "react";
import useFetchItemById from "../../../../../queries/useFetchItemById";
import { getBatchData, getPdfTemplateListData, getStudents } from "./api";
import useRegularRequest from "../../../../../queries/useRegularRequest";

// This is where all the initial querying of the data should reside.
export default function useSignFormResources({id, method = 'view'}) {
    const [studentDropdownData, setStudentDropdownData] = useState([]);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [s3Link, setS3Link] = useState(null);
    
    const [batch_student_id, setBatchStudentId] = useState(null);
    const [template_id, setTemplateId] = useState(null);
    const [student_id, setStudentId] = useState(null);

    const payload = {template_id, batch_student_id, student_id};

    const {
        // * What I undestand is the left side is the local variable inilized by the value from the right side.
        data: studentDataArray,
        fetchData: fetchStudentData,
        isLoading: isFetchingStudentData,
    } = useFetchItemById({fetcher: getStudents, moduleName: method});

    useEffect(() => {
        if (!studentDataArray) return;

        setStudentDropdownData(studentDataArray.map(item => ({
            value: item.id,
            label: item.enrolment.name
        })));
    }, [studentDataArray]);

    const {
        data: batchData,
        fetchData: fetchBatchData,
        isLoading: isFetchingBatchData,
    } = useFetchItemById({fetcher: getBatchData, moduleName: method});

    const [pdfTemplateDropdownData, setPdfTemplateDropdownData] = useState([]);
    const {
        data: pdfTemplateData,
        fetchData: fetchPdfTemplateListData,
        isLoading: isFetchingPdfTemplateListData,
    } = useFetchItemById({fetcher: getPdfTemplateListData, moduleName: 'get'});

    const isLoadingResources = useMemo(() => {
        return isFetchingStudentData === true 
        || isFetchingBatchData === true
        || isFetchingPdfTemplateListData === true;
    }, [isFetchingStudentData, isFetchingBatchData, isFetchingPdfTemplateListData]);

    // same as useEffect
    useLayoutEffect(() => {fetchStudentData({id: id})}, [fetchStudentData]);
    useLayoutEffect(() => {fetchBatchData({id: id})}, [fetchBatchData]);
    // ! id: 1 is a workaround because importing the regular useFetch
    // ! for listing is a hassle to import from PUB according to Aljonm
    // TODO Mark Aljon please import the regular listing get
    useLayoutEffect(() => {fetchPdfTemplateListData({id: 1})}, [fetchPdfTemplateListData]);
    
    useEffect(() => {
        if (!pdfTemplateData) return;

        setPdfTemplateDropdownData(pdfTemplateData.map(item => ({
            value: item.id,
            label: item.filename
        }))); 
    }, [pdfTemplateData]);

    return {
        id,
        studentDataArray,
        studentDropdownData,
        fetchStudentData,

        batchData,
        fetchBatchData,

        pdfTemplateData,
        pdfTemplateDropdownData,
        fetchPdfTemplateListData,
        isLoadingResources,

        pdfUrl,
        setPdfUrl,
        batch_student_id, setBatchStudentId,
        template_id, setTemplateId,
        student_id, setStudentId,
        payload,

        s3Link, setS3Link,
    }
}